import React from 'react';
import { Layout } from '../components/Layout';
export function PrivacyPage() {
  return <Layout data-id="element-419">
      <div className="py-16 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-420">
        <div className="max-w-7xl mx-auto" data-id="element-421">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-422">
            Privacy <br data-id="element-423" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-424">
              Policy
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-425">
            How we handle and protect your data.
          </p>
        </div>
      </div>
      <section className="py-16 px-6 bg-white" data-id="element-426">
        <div className="max-w-4xl mx-auto prose prose-charcoal" data-id="element-427">
          <h2 className="text-3xl font-bold mb-6" data-id="element-428">1. Information Collection</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-429">
            We collect information you provide, such as for quotes, surveys, or
            photo uploads.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-430">2. Use of Information</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-431">
            We use the information we collect to provide, maintain, and improve
            our services, to communicate with you, and to provide custom quotes.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-432">3. Data Security</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-433">
            We implement reasonable security measures to protect your personal
            information from unauthorized access or disclosure.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-434">4. Third-Party Sharing</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-435">
            We do not sell your personal information to third parties. We may
            share information with service providers who assist us in our
            business operations.
          </p>
        </div>
      </section>
    </Layout>;
}